import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

const DeleteConfirmModal = ({
  visible,
  onConfirm,
  onCancel,
  message,
  title,
  confirmText,
  cancelText,
  confirmLoading,
  confirmVariant = 'destructive',
  contentClassName,
  overlayClassName,
}) => {
  const { t } = useTranslation();
  return (
    <AlertDialog open={visible} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent className={contentClassName} overlayClassName={overlayClassName}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title || t('common.confirm')}</AlertDialogTitle>
          <AlertDialogDescription>{message || t('handbook.deleteConfirmMessage')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="outline" onClick={onCancel} disabled={confirmLoading}>
              {cancelText || t('handbook.deleteCancel')}
            </Button>
          </AlertDialogCancel>
          <Button
            variant={confirmVariant}
            className={confirmVariant === 'default' ? 'bg-[#20766F] hover:bg-[#20766F]/90' : undefined}
            onClick={onConfirm}
            disabled={confirmLoading}
          >
            {confirmLoading ? t('common.loading') : confirmText || t('handbook.deleteConfirm')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

DeleteConfirmModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmLoading: PropTypes.bool,
  confirmVariant: PropTypes.oneOf(['destructive', 'default']),
  contentClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
};

DeleteConfirmModal.defaultProps = {
  confirmLoading: false,
};

export default DeleteConfirmModal;
